import React from "react";
import {
  Container,
  Paper,
  Button,
  IconButton,
  Typography,
  TextField,
  InputAdornment
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import swal from "sweetalert";
import * as userApi from "../../api/userApi";
import ScrollToTopBtn from "../common/ScrollToTop";
import { withRouter } from "../common/WithRouter";

class UserList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      filteredUsers: [],
      searchQuery: "",
      loading: false,
    };
  }

  async componentDidMount() {
    try {
      const users = await userApi.getAllUsers();
      if (users) {
        users.sort((a, b) => a.userName.localeCompare(b.userName));
        this.setState({ users, filteredUsers: users });
      }
    } catch (error) {
      console.error("Error fetching users", error);
    }
  }

  handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    this.setState({
      searchQuery: query,
      filteredUsers: this.state.users.filter(
        (user) =>
          user.userName.toLowerCase().includes(query) ||
          user.companyName.toLowerCase().includes(query) ||
          user.userEmail.toLowerCase().includes(query)
      ),
    });
  };

  handleDeleteUser = (user) => {
    swal({
      title: "Slette bruker?",
      text: user.userName,
      icon: "warning",
      buttons: ["Avbryt", "OK"],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await userApi.deleteUser(user.userId);
          if (response) {
            this.setState({ users: this.state.users.filter((u) => u.userId !== user.userId) });
            swal("Bruker er slettet!", { icon: "success" });
          }
        } catch (error) {
          console.error("Error deleting user", error);
        }
      }
    });
  };

  handleClick = () => {
    swal({
      title: "Tilbakestille passord?",
      text:
        'Sette et nytt og tilfeldig passord på samtlige brukere.\n Alle må benytte "glemt passord"-funksjonen for å få tilgang til kontoen igjen.',
      icon: "warning",
      buttons: ["Avbryt", "OK"],
      dangerMode: true,
    }).then(async (ok) => {
      if (ok) {
        this.setState({ loading: true });
        try {
          const response = await userApi.pwdReset();
          if (response) {
            this.setState({ loading: false });
            swal("Passord er nå tilbakestilt for alle brukere!", { icon: "success" });
          } else {
            swal("Noe gikk feil...", { icon: "error" });
          }
        } catch (error) {
          console.error("Error resetting passwords", error);
        }
      }
    });
  };

  render() {
    const columns = [
      {
        field: "actions",
        headerName: "",
        width: 150,
        sortable: false,
        renderCell: (params) => (
          <Button
            variant="outlined"
            size="medium"
            color="primary"
            onClick={() =>
              this.props.navigate(`/userdetail/${params.row.userName}`)
            }
          >
            <ArrowForwardIosIcon sx={{ mr: 1 }} />
            Vis Mer
          </Button>
        ),
      },
      { field: "userName", headerName: "Brukernavn", flex: 1 },
      { field: "companyName", headerName: "Bedrift", flex: 1 },
      { field: "userEmail", headerName: "E-post", flex: 1 },
      {
        field: "activeUser",
        headerName: "Aktiv",
        flex: 1,
        renderCell: (params) => <Typography>{params.value ? "Ja" : "Nei"}</Typography>,
      },
      {
        field: "lastLoginDate",
        headerName: "Sist pålogget",
        flex: 1,
        valueFormatter: (params) => {
          const date = params ? new Date(params) : "Aldri";
          return date && !isNaN(date) ? date.toISOString().split("T")[0] : "Aldri";
        },
      },
      {
        field: "delete",
        headerName: "",
        width: 100,
        sortable: false,
        renderCell: (params) => (
          <IconButton color="error" onClick={() => this.handleDeleteUser(params.row)}>
            <DeleteForeverIcon />
          </IconButton>
        ),
      },
    ];

    return (
      <Container maxWidth="lg">
        <main style={{ width: "100%", paddingTop: "80px" }}>
          <Paper sx={{ p: 3, width: "100%" }}>

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
              <Typography variant="h5">BRUKEROVERSIKT</Typography>

              <TextField
                placeholder="Search"
                variant="outlined"
                sx={{
                  width: "250px",
                  backgroundColor: "white",
                  borderRadius: 1,
                }}
                value={this.state.searchQuery}
                onChange={this.handleSearch}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            <div style={{ width: "100%" }}>
              <DataGrid
                rows={this.state.filteredUsers}
                columns={columns}
                pageSizeOptions={[5, 10, 50, 100]}
                disableSelectionOnClick
                getRowId={(row) => row.userId}
              />
            </div>
          </Paper>
          <div style={{ paddingTop: "20px", paddingBottom: "20px", display: "flex", justifyContent: "center" }}>
            <Button variant="outlined" color="error" onClick={this.handleClick}>
              Klikk her for å tilbakestille passord for alle brukere
            </Button>
          </div>
        </main>
        <ScrollToTopBtn />
      </Container>
    );
  }
}

export default withRouter(UserList);
